import type { IntegrationName, ModelName, OrgPlanName } from "@tellescope/tanstack-query";
import type { FeatureName } from "./types";

/**
 * The full feature surface each plan grants. `baseFeatures` are always ready;
 * `byIntegration` features are always enabled (part of the plan) but carry a
 * setup status derived from whether their powering integration is set up.
 *
 * Web owns this plan→feature mapping; the onboarding package owns which
 * integrations a plan offers and how they are set up.
 */
export const PLAN_FEATURES: Record<
  OrgPlanName,
  {
    baseFeatures: readonly FeatureName[];
    byIntegration: Partial<Record<IntegrationName, readonly FeatureName[]>>;
  }
> = {
  "Healthie-Text": {
    baseFeatures: ["contacts", "settings", "table_views", "files", "content"],
    byIntegration: { healthie: ["templates"], twilio: ["messaging", "call"] },
  },
};

/**
 * Default plan feature per model, so record-permission checks pick up plan
 * gating automatically without callers passing `feature`. Partial: unmapped
 * models are plan-ungated. Extend as models become plan-gated.
 */
export const MODEL_FEATURE_MAP: Partial<Record<ModelName, FeatureName>> = {
  table_views: "table_views",
  calendar_event_templates: "templates",
};

/**
 * Plans for which integration auto-sync gates record actions. Orgs on any other
 * plan (or an unknown plan) skip the integration action check entirely — their
 * actions are enabled regardless of an integration's auto-sync settings.
 */
export const ACTION_SYNC_GATED_PLANS: readonly OrgPlanName[] = ["Healthie-Text"];
